"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetcher = void 0;
var CacheLayerFetcher_1 = require("./CacheLayerFetcher");
var StreamrFetcher_1 = require("./StreamrFetcher");
var StreamrStorageFetcher_1 = require("./StreamrStorageFetcher");
function createFetcher(config, asset) {
    switch (config.type) {
        case "cache-layer":
            return new CacheLayerFetcher_1.CacheLayerFetcher(config, asset);
        case "streamr":
            return new StreamrFetcher_1.StreamrFetcher(config, asset);
        case "streamr-storage":
            return new StreamrStorageFetcher_1.StreamrStorageFetcher(config, asset);
        default:
            throw new Error("Data source type is not supported: " + config.type);
    }
}
exports.createFetcher = createFetcher;
//# sourceMappingURL=index.js.map